// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"222":"98da24ae442880923a8e94b3fd953b8e","450":"d3ef867c9c2bb82b028463d0835e0847","673":"4051f2c53b97381ab04ad689fd7c899f","748":"c10cfc5bed29faa6f78410944724a13c","948":"e6b35a7e6c737016106b83b0f043f616"}[chunkId] + ".js";
};